import { useEffect, useState } from "react";
import { useMsal, useMsalAuthentication } from "@azure/msal-react";
import { Editor } from 'react-draft-wysiwyg';
import { convertFromHTML, EditorState, ContentState } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import Modal from "../Modal/Modal";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import { protectedResources } from "../../authConfig";
import { IFAQ } from "../../model/FAQ.model";
import { useForm } from "react-hook-form";
import parse from 'html-react-parser';
import './EditFAQsComponent.scss';

const EditFAQsComponent: React.FC = () => {
  // get functions to build form with useForm() hook
  const { register, handleSubmit, reset } = useForm();
  const [addinFAQ, updateAddingFAQ] = useState(false);
  const [updatingFAQ, updateUpdatingFAQ] = useState(null);
  const [deletingFAQ, updateDeletingFAQ] = useState<null | IFAQ>(null)
  const { instance } = useMsal();
  const [account, setAccount] = useState(instance.getActiveAccount());
  const { error, execute } = useFetchWithMsal({
    scopes: protectedResources.apiCFSkillPath.scopes.write,
  });
  const [editorState, setEditorState] = useState(EditorState.createEmpty());// Toolbar configuration
  const toolbarOptions = {
    options: ['inline', 'list', 'link', 'history'],
    inline: {
      options: ['bold', 'italic', 'underline'],
    },
    list: {
      options: ['unordered', 'ordered'],
    },
    link: {
      options: ['link', 'unlink'],
    },
    history: {
      options: ['undo', 'redo']
    }
  };
  const [loading, setLoading] = useState(false);
  const [callErr, setErr] = useState(null);
  const [faqs, setFAQs] = useState([]);
  const [maxIndex, setMaxIndex] = useState(0);
  const generateMaxIndex = () => {
    let i = faqs.reduce((v, sl: any) => {
      if (sl.indexNumber > v) return sl.indexNumber;
      return v;
    }, 0);
    if (i !== maxIndex) setMaxIndex(i);
  };
  const getFAQs = () => {
    let acc = account;
    setLoading(true);
    execute("GET", `/api/FAQs`)
      .then((response) => {
        if (response.error) {
          return;
        }
        //setSLData(response);
        setFAQs(response);
        generateMaxIndex();
        setLoading(false);
        //setOdataStringSt(odataString);
      })
      .catch((err) => {
        setErr(err);
        setLoading(false);
      });
  };
  const toggleAddingFAQ = () => {
    updateAddingFAQ(!addinFAQ);
  };

  const addNewFAQ = (event: any) => {
    event.preventDefault();
    let acc = account;
    const formData = new FormData(event.target);
    let questionI = formData.get("question") + "";
    let answerI = formData.get("answer") + "";
    let faq: IFAQ = {
      faqId: "",
      indexNumber: maxIndex + 1,
      question: questionI,
      answer: answerI,
      status: "A",
      createdDate: "",
      CreatedBy: "",
      lastModifiedDate: "",
      lastModifiedBy: "",
    };
    execute("POST", `/api/FAQ/addFAQ`, faq as any)
      .then((response) => {
        if (response.error) {
          return;
        }
        //setSLData(response);
        (faqs as any).push(response);
        setFAQs(faqs);
        generateMaxIndex();
        setLoading(false);
        //setOdataStringSt(odataString);
      })
      .catch((err) => {
        setErr(err);
        setLoading(false);
      });
    toggleAddingFAQ();
  };
  const toggleUpdatingFAQ = (event: any) => {
    if (!event) {
      updateUpdatingFAQ(null);
      return;
    }
    let id = event.target.name;
    if (!id) {
      updateUpdatingFAQ(null);
      return;
    }
    var faq = faqs.find((x: any) => x.faqId === id);
    if (!faq) {
      updateUpdatingFAQ(null);
      return;
    }
    var faqi = faq as IFAQ;
    var faqa = convertFromHTML((faqi.answer) ? faqi.answer : "");
    const faqaCS = ContentState.createFromBlockArray(faqa.contentBlocks, faqa.entityMap);
    const faqaES = EditorState.createWithContent(faqaCS);
    console.log('toggleUpdatingFAQ')
    setEditorState(faqaES);
    //editorState.clear();
    // 
    /*
    editorState.update(faqaCS);
    setEditorState(faqaCS);
    onEditorStateChange(faqaCS)*/
    //update editor state
    updateUpdatingFAQ(faq);
  };
  const toggleDeletingFAQ = (event: any) => {
    if (!event) {
      updateDeletingFAQ(null);
      return;
    }
    let id = event.target.name;
    if (!id) {
      updateDeletingFAQ(null);
      return;
    }
    var faq = faqs.find((x: any) => x.faqId === id);
    if (!faq) {
      updateDeletingFAQ(null);
      return;
    }
    updateDeletingFAQ(faq);
  };
  const updateFAQ = (event: any) => {
    event.preventDefault();

    let acc = account;
    const formData = new FormData(event.target);
    let questionI = formData.get("question") + "";
    let answerI = "";//formData.get("answer") + "";
    if (editorState.getCurrentContent) {
      answerI = stateToHTML(editorState.getCurrentContent());
    }
    (updatingFAQ as any).question = questionI;
    (updatingFAQ as any).answer = answerI;
    execute("PUT", `/api/FAQ/updateFAQ`, updatingFAQ as any)
      .then((response) => {
        if (response.error) {
          return;
        }
        //setSLData(response);
        //(faqs as any).push(response);
        setFAQs(faqs);
        setLoading(false);
        updateUpdatingFAQ(null);
        //setOdataStringSt(odataString);
      })
      .catch((err) => {
        setErr(err);
        setLoading(false);
      });
  };
  const onEditorStateChange = (newEditorState: EditorState) => {
    console.log('onEditorStateChange')
    //debugger;
    setEditorState(newEditorState);
    const contentState = editorState.getCurrentContent();
    //setDescription( stateToHTML(contentState));
  };
  useEffect(() => {
    // reset form with user data
    if (updatingFAQ) {
      reset(updatingFAQ);
    }
  }, [updatingFAQ]);
  const deleteTheFAQ = () => {
    if (!deletingFAQ || !account) return;
    execute("DELETE", `/api/FAQ/deleteFAQ/${deletingFAQ?.faqId}`, undefined)
      .then((response) => {
        if (response.error) {
          return;
        }
        //setSLData(response);
        if (!deletingFAQ) return;
        (faqs as IFAQ[]).splice((faqs as IFAQ[]).indexOf(deletingFAQ as IFAQ), 1);
        setFAQs(faqs);
        generateMaxIndex();
        updateDeletingFAQ(null);
        setLoading(false);
        //setOdataStringSt(odataString);
      })
      .catch((err) => {
        setErr(err);
        setLoading(false);
      });
  }
  const CancelEditing = () => {
    updateUpdatingFAQ(null);
    updateAddingFAQ(false);
    updateDeletingFAQ(null);
  }
  if (!loading && faqs.length < 1) {
    getFAQs();
  }
  return (
    <div className="max-width">
      <Modal isOpen={deletingFAQ !== null} modalTitle="Delete FAQ" onClose={CancelEditing}>
        <div className="modal-form-content-scroll-container">
          <div className="m-b-1">Are you sure you want to delete the question: </div>
          <div>{deletingFAQ?.question}</div>
        </div>
        <div className="modal-form-button-container two-button">
          <button className="btn-med-gray" onClick={CancelEditing}>No</button>
          <button className="btn-secondary" onClick={deleteTheFAQ}>Yes</button>
        </div>
      </Modal>
      <h2 className="m-b-2 h1-size">Edit FAQs</h2>
      <ul className="reset edit-faqs-ul">
        {faqs.length > 0 &&
          faqs.map((faq) => (
            <>
              <li className="m-b-2">
                <div className="dis-flex gap-1">
                  <label className="m-b--25"><b>Question:</b></label>
                  {(faq as any).question}
                </div>
                
                <div className="dis-flex gap-1">
                  <label className="m-b--25"><b>Answer:</b></label>
                  {parse((faq as any).answer)}
                </div>
                <div className="m-t--50">
                  <input
                    className="btn-outlined-primary"
                    type="button"
                    name={(faq as any).faqId}
                    onClick={toggleUpdatingFAQ}
                    value={"Update"}
                  /> &nbsp;
                  <input
                    className="btn-outlined-primary"
                    type="button"
                    name={(faq as any).faqId}
                    onClick={toggleDeletingFAQ}
                    value={"Delete"}
                  />
                </div>
              </li>

            </>
          ))}
      </ul>
      {updateFAQ !== null && (
        <Modal modalTitle="Update FAQ" isOpen={updatingFAQ !== null} onClose={CancelEditing}>
          <form onSubmit={updateFAQ}>
            <div className="modal-form-content-scroll-container">
              <div className="form-group m-b-1">
                <label htmlFor="question">Question</label>
                <input id="question" type="text" {...register('question')} className="form-control" />
              </div>
              <div className="form-group edit-faqs-form-group-editor-container">
                <label>Answer</label>
                <Editor editorState={editorState} onEditorStateChange={onEditorStateChange} toolbar={toolbarOptions} />
              </div>
              {/* allows for full editor to display in modal */}
              <div>&nbsp;</div>
            </div>
            
            <div className="modal-form-button-container two-button">
              <input className="btn-med-gray" type="button" onClick={toggleUpdatingFAQ} value={"Cancel"} />
              <button className="btn-secondary" type="submit">Update</button>
            </div>
          </form>
        </Modal>
      )}
      <Modal modalTitle="Add FAQ" isOpen={addinFAQ} onClose={CancelEditing}>
        <form onSubmit={addNewFAQ}>
          <div className="modal-form-content-scroll-container">
            <div className="form-group m-b-1">
              <label htmlFor="question">Question</label>
              <input id="question" type="text" name="question" />
            </div>
            <div className="form-group edit-faqs-form-group-editor-container">
              <label htmlFor="answer">Answer</label>
              <input id="answer" type="text" name="answer" />
            </div>
          </div>
          <div className="modal-form-button-container two-button">
            <input className="btn-med-gray" type="button" onClick={toggleAddingFAQ} value={"Cancel"} />
            <button className="btn-secondary" type="submit">Add Question</button>
          </div>
        </form>
      </Modal>
      <div className="aln-center m-t-2">
        <input className="btn-secondary" type="button" onClick={toggleAddingFAQ} value={"Add FAQ"} />
      </div>
      
    </div>
  );
};

export default EditFAQsComponent;
